import { Component, ElementRef, OnInit } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-columns',
  templateUrl: './columns.component.html',
  host: {
    class: 'uex-card-columns card-columns'
  }
})
export class CardColumnsComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
